import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../contexts/LanguageContext';

const ContactContainer = styled.div`
  padding: 50px;
  color: #727272;
  font-family: 'Raleway', sans-serif;
`;

const BlockTitle = styled.h3`
  font-size: 20px;
  line-height: 26px;
  margin: 0 0 30px 0;
  font-weight: 500;
  text-transform: uppercase;
  color: #333;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
`;

const Col = styled.div<{ md?: number }>`
  flex: ${props => props.md ? `0 0 ${(props.md / 12) * 100}%` : '1'};
  padding: 0 15px;
  
  @media (max-width: 768px) {
    flex: 0 0 100%;
    margin-bottom: 30px;
  }
`;

const ContactContent = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 30px;
`;

const ContactIcon = styled.div`
  margin-right: 20px;
  
  i {
    font-size: 24px;
    color: #F34452;
    width: 30px;
  }
`;

const ContactDetails = styled.div`
  h5 {
    font-size: 16px;
    margin: 0 0 5px 0;
    color: #333;
    text-transform: uppercase;
    font-weight: 700;
  }
  
  p {
    margin: 0;
    line-height: 24px;
  }
`;

const ContactSocial = styled.div`
  margin-top: 30px;
  
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
      display: inline-block;
      margin-right: 15px;
    }
    
    a {
      color: #F34452;
      font-size: 24px;
      transition: all 0.3s;
      
      &:hover {
        color: #d63946;
        transform: scale(1.1);
      }
    }
  }
`;

const ContactImage = styled.div`
  text-align: center;
  
  img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  }
`;

const EmailSection = styled.div`
  text-align: center;
  padding: 30px 0;
  border-top: 1px solid #eee;
  margin-top: 30px;
  
  a {
    background: #F34452;
    color: #FFF;
    padding: 15px 30px;
    text-decoration: none;
    text-transform: lowercase;
    font-weight: 700;
    display: inline-block;
    margin-bottom: 15px;
    
    &:hover {
      background: #d63946;
      color: #FFF;
    }
  }
  
  small {
    display: block;
    color: #727272;
    font-size: 14px;
  }
`;

const Contact: React.FC = () => {
  const { t } = useLanguage();
  
  return (
    <ContactContainer>
          <BlockTitle>{t('contact.getInTouch')}</BlockTitle>
          
          <Row>
            <Col md={6}>
              <ContactContent>
                <ContactIcon>
                  <i className="fa fa-map-marker"></i>
                </ContactIcon>
                <ContactDetails>
                  <h5>{t('contact.location')}</h5>
                  <p>New York City Metropolitan Area</p>
                </ContactDetails>
              </ContactContent>
              
              <ContactContent>
                <ContactIcon>
                  <i className="fa fa-envelope"></i>
                </ContactIcon>
                <ContactDetails>
                  <h5>{t('contact.email')}</h5>
                  <p>yuanyuanli2022@gmail.com</p>
                </ContactDetails>
              </ContactContent>
              
              <ContactSocial>
                <ul>
                  <li>
                    <a href="https://www.linkedin.com/in/yuanyuanmaggie" target="_blank" rel="noopener noreferrer">
                      <i className="fa fa-linkedin"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://github.com/YuanyuanMaggie" target="_blank" rel="noopener noreferrer">
                      <i className="fa fa-github"></i>
                    </a>
                  </li>
                </ul>
              </ContactSocial>
            </Col>
            
            <Col md={6}>
              <ContactImage>
                <img loading="lazy" decoding="async" src="/images/bg/me-big.webp" alt="Yuanyuan Li" />
              </ContactImage>
            </Col>
          </Row>
          
          <EmailSection>
            <a href="mailto:yuanyuanli2022@gmail.com">yuanyuanli2022@gmail.com</a>
            <small>{t('contact.contactMessage')}</small>
          </EmailSection>
    </ContactContainer>
  );
};

export default Contact;